module.exports = __webpack_public_path__ + "media/images/company-profile-20cc3005b57eaa38c87a57bbcd96b2c4.png";